import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";

const THEME_STORAGE_KEY = "callis.theme";
const THEME_TRANSITION_MS = 240;

const getSavedTheme = () => {
  const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
  return savedTheme === "light" || savedTheme === "dark" ? savedTheme : null;
};

function useTheme() {
  const [theme, setTheme] = useState<"light" | "dark">(() => getSavedTheme() || "light");
  const transitionTimeout = useRef<number | undefined>(undefined);

  const onChangeTheme = useCallback(() => {
    document.documentElement.dataset.themeTransition = "";
    window.clearTimeout(transitionTimeout.current);
    transitionTimeout.current = window.setTimeout(() => {
      delete document.documentElement.dataset.themeTransition;
    }, THEME_TRANSITION_MS);

    setTheme((prevTheme) => {
      const nextTheme = prevTheme === "light" ? "dark" : "light";
      localStorage.setItem(THEME_STORAGE_KEY, nextTheme);
      return nextTheme;
    });
  }, []);

  useEffect(() => () => {
    window.clearTimeout(transitionTimeout.current);
    delete document.documentElement.dataset.themeTransition;
  }, []);

  // 사용자가 시스템 설정으로 다크모드를 사용하고 있다면
  useLayoutEffect(() => {
    if (getSavedTheme()) {
      return;
    }

    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      setTheme("dark");
    } else {
      setTheme("light");
    }
  }, []);
  return {
    theme,
    onChangeTheme,
  };
}

export default useTheme;
